import { FilterAltOutlined } from '@mui/icons-material'
import { Chip, ChipProps } from '@mui/material'

export const TrackingsProjectFilterChip: React.FC<{
    projectName: React.ReactNode
    onDelete?: ChipProps['onDelete']
}> = ({ projectName, onDelete }) => (
    <Chip
        icon={<FilterAltOutlined fontSize={'small'} />}
        label={projectName}
        onDelete={onDelete}
    />
)
